(function () {
  "use strict";

  angular
    .module("alk.directives")
    .directive("tidPassword", ($compile) => {
      return {
        restrict: "A",
        require: "ngModel",
        scope: {
        },
        link: function (scope, element, attrs, ngModel) {

          ngModel.$validators.tidPassword = function (password) {
            if (!password) {
              return true;
            }
            const validationObj = {};
            validationObj.length = password.length >= 8 && password.length <= 20;
            validationObj.lowercase = /[a-z]/.test(password);
            validationObj.uppercase = /[A-Z]/.test(password);
            validationObj.number = /\d/.test(password);
            validationObj.specialCharacter = /[!@#$%&*^_\-+]/.test(password);
            validationObj.overall = Object.values(validationObj).every((isTrue) => {
              return isTrue;
            });
            return validationObj.overall;
          };
          ngModel.$validators.hasLength = function (password) {
            if (!password) {
              return true;
            }
            const length = password.length >= 8 && password.length <= 20;
            return length;
          };
          ngModel.$validators.hasLowercase = function (password) {
            if (!password) {
              return true;
            }
            const lowercase = /[a-z]/.test(password);
            return lowercase;
          };
          ngModel.$validators.hasUppercase = function (password) {
            if (!password) {
              return true;
            }
            const uppercase = /[A-Z]/.test(password);
            return uppercase;
          };
          ngModel.$validators.hasNumber = function (password) {
            if (!password) {
              return true;
            }
            const number = /\d/.test(password);
            return number;
          };
          ngModel.$validators.hasCharacter = function (password) {
            if (!password) {
              return true;
            }
            const specialCharacter = /[!@#$%&*^_\-+]/.test(password);
            return specialCharacter;
          };
        }
      };
    });
})();



// WEBPACK FOOTER //
// ./Common Javascript Files/AngularJS/alk-validation/tid-password.js